import { render } from "./UserReturn.vue?vue&type=template&id=7b7e6706"
import script from "./UserReturn.vue?vue&type=script&lang=js"
export * from "./UserReturn.vue?vue&type=script&lang=js"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__